export default "__VITE_ASSET__n8BuR1gy__"